import { Table } from "antd"
import { useEffect, useState } from "react"
import { useQuery } from "react-query"
import { AxiosError } from "axios"
import Column from "antd/lib/table/Column"
import { Link } from "react-router-dom"
import useOpus from "contexts/opus/hooks/use-opus"
import { IFailedRenewalViewModel } from "contexts/opus/context"
import formatDate from "dateformat"

export const RenewalsPendingManualReview: React.FunctionComponent = (props) => {
  const [renewals, setRenewals] = useState<IFailedRenewalViewModel[]>([])
  const opus = useOpus()

  const { isFetching, refetch } = useQuery<
    IFailedRenewalViewModel[] | undefined,
    AxiosError
  >(
    ["renewals-pending-manual-review"],
    async () => opus.renewalClient.getRenewalsPendingManualReview() || [],
    {
      onSuccess: (result) => {
        if (result) {
          setRenewals(result)
        }
      }
    }
  )

  useEffect(() => {
    if (isFetching === false && renewals === null) {
      refetch()
    }
  })

  return (
    <Table
      scroll={{ x: "max-content" }}
      loading={isFetching}
      dataSource={renewals}
      rowKey="policyId"
      pagination={{
        defaultPageSize: 10,
        hideOnSinglePage: true,
        position: ["bottomCenter"],
        size: "small"
      }}
    >
      <Column
        title="Policy Reference"
        dataIndex="policyReferenceID"
        key="policyReferenceID"
        render={(policyReferenceID, record: IFailedRenewalViewModel) =>
          policyReferenceID && (
            <Link to={`/policy/${record.policyId}/summary`}>
              {policyReferenceID}
            </Link>
          )
        }
      />
      <Column title="Client Name" dataIndex="clientName" />
      <Column
        title="Cover Start Date"
        dataIndex="coverStartDate"
        render={(date: string) => formatDate(new Date(date), "dd/mm/yyyy")}
      />
      <Column
        title="Cover End Date"
        dataIndex="coverEndDate"
        render={(date: string) => formatDate(new Date(date), "dd/mm/yyyy")}
      />
    </Table>
  )
}
